import * as yup from 'yup';
import { regexOnlyNumber } from 'shell/constants/regex';
import { DateTime } from 'luxon';
import { PracticeEditResidence } from 'practice/view-models/practice-edit-residence';

const validationShema = yup
  .object({
    effectiveDate: yup
      .date()
      .typeError('Data non valida')
      .required('Campo richiesto')
      .nullable()
      .max(DateTime.now().plus({ day: 1 }), 'La data deve essere minore uguale ad oggi'),
    subscriptionNumber: yup
      .string()
      .nullable()
      .matches(regexOnlyNumber, 'Campo numerico')
      .when('citizenshipNumber', {
        is: 100,
        then: yup
          .string()
          .nullable()
          .matches(regexOnlyNumber, 'Campo numerico')
          .required('Campo obbligatorio'),
        otherwise: yup.string().nullable().matches(regexOnlyNumber, 'Campo numerico').notRequired(),
      }),
    dateSubscriptionNumber: yup
      .date()
      .nullable()
      .typeError('Data non valida')
      .when('citizenshipNumber', {
        is: 100,
        then: yup.date().nullable().typeError('Data non valida').required('Campo obbligatorio'),
        otherwise: yup.date().nullable().typeError('Data non valida').notRequired(),
      }),
    citizenshipNumber: yup.number().nullable(),
  })
  .test('foreignState', 'Controllo', (values) => {
    const castedValues = values as unknown as PracticeEditResidence;

    if (
      castedValues.residence?.checkedResidence &&
      !castedValues.residence?.foreign?.foreignState?.id
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'residence.foreign.foreignState'
      );
    }

    return true;
  })
  .test('foreignMunicipality', 'Controllo', (values) => {
    const castedValues = values as unknown as PracticeEditResidence;

    if (
      castedValues.residence?.checkedResidence &&
      !castedValues.residence?.foreign?.municipality?.description
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'residence.foreign.municipality'
      );
    }

    return true;
  })
  .test('foreignAddress', 'Controllo', (values) => {
    const castedValues = values as unknown as PracticeEditResidence;

    if (castedValues.residence?.checkedResidence && !castedValues.residence?.foreign?.address) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'residence.foreign.address');
    }

    return true;
  });

export default validationShema;
